const ACCESS_MODES = Object.freeze({
  FULL: "full",
  GRACE: "grace",
  LANDING_ONLY: "landing_only",
  SUSPENDED: "suspended",
});

function validDate(value) {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

function daysUntil(value, now = new Date()) {
  const date = validDate(value);
  if (!date) return null;
  return Math.max(0, Math.ceil((date.getTime() - now.getTime()) / 86400000));
}

export function getProjectBillingAccess(project, now = new Date()) {
  const billing = project?.billing || {};
  const billingStatus = String(billing.status || "trial").toLowerCase();
  const projectStatus = String(project?.status || "active").toLowerCase();
  const explicitMode = String(billing.accessMode || "").toLowerCase();
  const graceUntil = validDate(billing.graceUntil);

  let mode = ACCESS_MODES.FULL;
  let reason = "billing_active";

  if (projectStatus === "cancelled") {
    mode = ACCESS_MODES.SUSPENDED;
    reason = "project_cancelled";
  } else if (projectStatus === "paused" && billing.pausedByBilling !== true) {
    mode = ACCESS_MODES.SUSPENDED;
    reason = "project_paused_by_admin";
  } else if (billingStatus === "past_due") {
    if (graceUntil && now <= graceUntil) {
      mode = ACCESS_MODES.GRACE;
      reason = "payment_grace_period";
    } else {
      mode = ACCESS_MODES.LANDING_ONLY;
      reason = "payment_grace_expired";
    }
  } else if (["paused", "cancelled"].includes(billingStatus)) {
    mode = ACCESS_MODES.LANDING_ONLY;
    reason = billingStatus === "cancelled"
      ? "subscription_cancelled"
      : "subscription_paused";
  } else if (explicitMode === ACCESS_MODES.LANDING_ONLY) {
    mode = ACCESS_MODES.LANDING_ONLY;
    reason = "billing_restricted";
  } else if (explicitMode === ACCESS_MODES.GRACE) {
    mode = ACCESS_MODES.GRACE;
    reason = "payment_grace_period";
  } else if (explicitMode === ACCESS_MODES.SUSPENDED) {
    mode = ACCESS_MODES.SUSPENDED;
    reason = "project_suspended";
  }

  return {
    mode,
    reason,
    billingStatus,
    projectStatus,
    graceUntil,
    restrictedAt: validDate(billing.restrictedAt),
    daysRemaining: daysUntil(graceUntil, now),
    isFull: mode === ACCESS_MODES.FULL,
    isGrace: mode === ACCESS_MODES.GRACE,
    isLandingOnly: mode === ACCESS_MODES.LANDING_ONLY,
    isSuspended: mode === ACCESS_MODES.SUSPENDED,
    isOperational: [ACCESS_MODES.FULL, ACCESS_MODES.GRACE].includes(mode),
    needsPaymentAction: mode === ACCESS_MODES.GRACE || mode === ACCESS_MODES.LANDING_ONLY,
  };
}

export function billingAccessLabel(access) {
  if (access?.isGrace) return "Pago pendiente · período de gracia";
  if (access?.isLandingOnly) return "Funciones pausadas por pago";
  if (access?.isSuspended) return "Proyecto suspendido";
  return "Servicio activo";
}

export { ACCESS_MODES };
